import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Section, Eyebrow } from "@/components/PublicLayout";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/contact", form); setSent(true); toast.success("Message sent. We'll reply from admissions@simo.university."); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };
  return (
    <Section className="py-16 md:py-24 max-w-2xl">
      <Eyebrow>Contact</Eyebrow>
      <h1 className="font-serif text-4xl md:text-6xl tracking-tight text-ink">Speak with Simo</h1>
      <p className="mt-4 text-ink/65">Admissions, programmes, partnerships or press — reach us and we'll route your message to the right office.</p>
      {sent ? (
        <p className="mt-8 text-heraldic text-lg">Thank you. Your message has been received.</p>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-4">
          <Input data-testid="contact-name" required placeholder="Full name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="rounded-sm" />
          <Input data-testid="contact-email" required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="rounded-sm" />
          <Input data-testid="contact-subject" placeholder="Subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className="rounded-sm" />
          <Textarea data-testid="contact-message" required placeholder="Your message" rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="rounded-sm" />
          <button data-testid="contact-submit" className="bg-heraldic text-white px-7 py-3 rounded-sm hover:bg-heraldic-700 transition-colors">Send message</button>
        </form>
      )}
    </Section>
  );
}
